// Lucide icon: message-square-more (https://lucide.dev/icons/message-square-more)
import { MessageSquareMore } from 'lucide-react'

import { IconComponentStyled } from '../styles/IconComponentStyled'
import { type IIconComponentProps } from '../types'

export const IconMessage = (props: IIconComponentProps) => {
  return (
    <IconComponentStyled {...props}>
      <MessageSquareMore />
    </IconComponentStyled>
  )
}
